var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "customer-export-modal",
        title: _vm.$t("export_partner_modal_title"),
        actionLabel: _vm.$t("export"),
        successHandler: _vm.success ? null : _vm.handleExport
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c("template", { slot: "content" }, [
        !_vm.success
          ? _c(
              "div",
              [
                _c("p", [_vm._v(_vm._s(_vm.$t("export_partner_modal_body")))]),
                _c(
                  "q-field",
                  { attrs: { label: _vm.$t("format"), labelWidth: 4 } },
                  [
                    _c("q-select", {
                      attrs: { options: _vm.customerExportFormats },
                      model: {
                        value: _vm.formData.format,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "format", $$v)
                        },
                        expression: "formData.format"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              [
                _c("check-mark"),
                _c("h4", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.$t("export_successful_title")))
                ]),
                _c("p", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.$t("export_successful_body")))
                ])
              ],
              1
            )
      ]),
      _c("q-inner-loading", { attrs: { visible: _vm.loading } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }